export default [
    {
        path: "chatIndex",
        name: "chatIndex",
        component: () => import("@/components/chat/chatIndex.vue")
    }
]


// WEBPACK FOOTER //
// ./src/routers/chatRouter.js